<h2 mat-dialog-title>
    <div>
      <span *ngIf="notifications">Modifica Notifica: {{ notifications.title }}</span>
      <span *ngIf="!notifications">Nuova Notifica</span>
    </div>

    <div class="header-actions" *ngIf="notifications">
        <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
          <button mat-menu-item (click)="deleteNotification()">
            <mat-icon>delete</mat-icon>
            Elimina notifica
          </button>
        </mat-menu>
    </div>

</h2>
  
  <mat-dialog-content>
    <form [formGroup]="notificationsForm" novalidate> 
      <div class="u-flex-full">
        <mat-form-field class="u-full-width">
          <mat-label>Titolo</mat-label>
          <input matInput formControlName="title" placeholder="Titolo" required>
          <mat-error>Campo obbligatorio</mat-error>
        </mat-form-field>
  
        <mat-form-field class="u-full-width">
          <mat-label>Contenuto</mat-label>
          <input matInput formControlName="body" placeholder="Contenuto" required>
          <mat-error>Campo obbligatorio</mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <div class="left-actions">
      <button mat-raised-button  type="button" (click)="revert()"
        [disabled]="notificationsForm.pristine">
        Reset
      </button>
      <button mat-raised-button color="primary" type="button" (click)="save()"
        [disabled]="notificationsForm.pristine || !notificationsForm.valid">
        Salva
      </button>
    </div>
    <div>
      <button mat-raised-button type="button" (click)="close()">
        Chiudi
      </button>
    </div>
  </mat-dialog-actions>
  